"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _Icon = _interopRequireDefault(require("./Icon"));

var _jsxRuntime = require("react/jsx-runtime");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Notification = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Notification, _Component);

  var _super = _createSuper(Notification);

  function Notification(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Notification);
    _this = _super.call(this, props);
    _this.state = {
      hide: false
    };
    _this.handleRemoveNotification = _this.handleRemoveNotification.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Notification, [{
    key: "handleRemoveNotification",
    value: function handleRemoveNotification() {
      this.setState({
        hide: true
      });
      this.props.onRemoveNotification();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "card notification".concat(this.state.hide ? ' hide' : '').concat(this.props.viewed ? '' : ' background-lighter'),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "notification-content",
          onClick: this.props.onNotificationClick,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "information",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
              icon: this.props.icon
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              children: this.props.message
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "information",
              children: (0, _momentTimezone.default)(this.props.creationDate).fromNow()
            })]
          })]
        }), this.props.showDelete && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "action-bar",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            className: "button-square",
            onClick: this.handleRemoveNotification,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
              icon: "trash"
            })
          })
        })]
      });
    }
  }]);
  return Notification;
}(_react.Component);

Notification.propTypes = {
  creationDate: _propTypes.default.string.isRequired,
  icon: _propTypes.default.string.isRequired,
  message: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]).isRequired,
  onNotificationClick: _propTypes.default.func,
  onRemoveNotification: _propTypes.default.func.isRequired,
  viewed: _propTypes.default.bool,
  showDelete: _propTypes.default.bool
};
Notification.defaultProps = {
  onNotificationClick: function onNotificationClick() {},
  viewed: true,
  showDelete: false
};
var _default = Notification;
exports.default = _default;
//# sourceMappingURL=Notification.js.map